import axios from "axios";

const PREFIJO = "/api/TpPrs/"

export default {
    tipoPersona(){
        const dto = {
        }
        return axios.post(`${PREFIJO}VmLsTpPr`,dto);
    }
}